import types from '../../actions/types'

var initialState = {
  success: false,
}
export default (state = initialState, action) => {
  switch (action.type) {
    case types.QUERY_POST.OK:
      return {
        ...state,
        success: true,
      }
    case types.QUERY_POST.FAIL:
      return {
        ...state,
        success: false,
      }
    default:
      return state
  }
}
